import { render, staticRenderFns } from "./alarmMessage.vue?vue&type=template&id=2d2bc71b&scoped=true&"
import script from "./alarmMessage.vue?vue&type=script&lang=js&"
export * from "./alarmMessage.vue?vue&type=script&lang=js&"
import style0 from "./alarmMessage.vue?vue&type=style&index=0&id=2d2bc71b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2bc71b",
  null
  
)

export default component.exports